const fonts = {
  body: `"Josefin Sans", "sans-serif"`,
};

export default fonts;
